export default "__VITE_ASSET__BCs8bQTt__"